import { render, staticRenderFns } from "./ThgQuickCheckoutClosingCard.vue?vue&type=template&id=c4a56d54"
import script from "./ThgQuickCheckoutClosingCard.vue?vue&type=script&lang=ts"
export * from "./ThgQuickCheckoutClosingCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports